<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="locaisEntrega.content"
      class="elevation-1 mt-5 rounded-card"
      :loading="loading"
      :server-items-length="locaisEntrega.total"
      @update:options="updateOptions"
      :footer-props="footerOptions"
      no-data-text="Nenhum local de entrega encontrado"
      loading-text="Carregando locais de entrega..."
      :options="optionsList"
    >
      <template v-slot:item.codigoInterno="{ item }">
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <span v-on="on">
              {{ item.codigoInterno | naoInformado | truncate(15) }}
            </span>
          </template>
          <span>{{ item.codigoInterno | naoInformado}}</span>
        </v-tooltip>
      </template>
      <template v-slot:item.nomeLocal="{ item }">
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <span v-on="on">
              {{ item.nomeLocal | truncate(25) }}
            </span>
          </template>
          <span>{{ item.nomeLocal }}</span>
        </v-tooltip>
      </template>
      <template v-slot:item.observacoesInternas="{ item }">
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <span v-on="on">
              {{ item.observacoesInternas | truncate(50) }}
            </span>
          </template>
          <span>{{ item.observacoesInternas }}</span>
        </v-tooltip>
      </template>
      <template v-slot:item.endereco="{ item }">
        <v-icon>mdi-map-marker</v-icon>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <span v-on="on">
              {{ item.endereco | endereco | truncate(90) }}
            </span>
          </template>
          <span>{{ item.endereco | endereco }}</span>
        </v-tooltip>
      </template>
      <template v-slot:item.situcacao="{ item }">
        <px-ativo small :ativo="item.ativo"/>
      </template>
      <template v-slot:item.options="{ item }">
        <div class="text-right">
          <v-btn icon @click="goToLocalEntrega(item)">
            <v-icon>mdi-pencil</v-icon>
          </v-btn>
          <v-btn icon
                 @click="onClickDelete(item)">
            <v-icon>mdi-delete</v-icon>
          </v-btn>
        </div>
      </template>
    </v-data-table>
    <px-confirm-dialog ref="confirm"/>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  props: {
    locaisEntrega: Object,
    default: [],
    loading: Boolean,
    onChangeOptions: {
      type: Function,
      required: true,
    },
    optionsList: Object,
    footerOptions: Object,
  },
  data() {
    return {
      headers: [
        {
          text: 'Código',
          value: 'codigoInterno',
        },
        {
          text: 'Nome do local',
          value: 'nomeLocal',
        },
        {
          text: 'Observações internas',
          value: 'observacoesInternas',
        },
        {
          text: 'Endereço',
          value: 'endereco',
        },
        {
          text: 'Situação',
          value: 'situcacao',
        },
        {
          text: null,
          sortable: false,
          value: 'options',
        },
      ],
    };
  },
  computed: {
    ...mapGetters('user', ['hasRoleComprador']),
  },
  methods: {
    goToLocalEntrega(item) {
      this.$router.push({
        name: 'main.locais-entrega.edicao',
        params: {
          id: item.id,
        },
      });
    },
    updateOptions(options) {
      this.onChangeOptions(options);
    },
    remove(item) {
      this.$emit('remove', item);
    },
    onClickDelete(item) {
      this.$refs.confirm.open('Você deseja remover este local de entrega?',
        'Esta operação não pode ser desfeita.',
        { width: 450 })
        .then((confirm) => {
          if (!confirm) {
            return;
          }
          this.remove(item);
        });
    },
  },
};
</script>
